import React from "react";
type NoteTagProps = {
  children: React.ReactNode;
  className?: string;
};

/** Stakeholder annotation chip — deliberately off-brand yellow so it reads as markup, not UI. */
export function NoteTag({
  children,
  className = ""
}: NoteTagProps) {
  return <span className={`inline-flex items-center whitespace-nowrap rounded-sm bg-i9-note px-1.5 py-0.5 font-sans text-[10px] font-bold uppercase not-italic tracking-wide text-i9-ink ${className}`} data-id="element-150" data-mp="3oegqqglj5ucv">
      {children}
    </span>;
}